<template>
  <h1 class="header-marked h3"><slot /></h1>
</template>

<style>
  .header-marked {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

    .header-marked:before,
    .header-marked:after {
      content: '';
      height: 1px;
      background-color: var(--color-standard);
      flex: 1;
    }

    .header-marked:before {
      margin-right: 5%;
    }

    .header-marked:after {
      margin-left: 5%;
    }
</style>
